import { MealPaymentType } from '../settlementMeals';

export enum MethodOfCalcTheFee {
    HOURLY = 'HOURLY',
    MONTHLY = 'MONTHLY',
}

export type SettlementStaysDTO = {
    settlementType: MealPaymentType;
    paymentType: MethodOfCalcTheFee;
    freeHours: boolean | null;
    price: number | null;
    freeHoursAmount: number | null;
    freeHoursTimeFrame: boolean | null;
    freePeriodStart: string | null;
    freePeriodEnd: string | null;
};

export type SettlementV2StaysDTO = {
    paymentType: 'PREPAID' | 'POSTPAID';
    settlementSetting: {
        freeHoursAmount: number;
        timeRouningUnitMinutes: number;
        costPerHour: number;
        stayFeeType: 'FLAT_MONTHLY' | 'PER_UNIT';
        stayTimeType: 'FREE_PERIOD' | 'TIME_INTERVAL';
    };
    stayFeeType: 'FLAT_MONTHLY' | 'PER_UNIT';
    stayTimeType: 'FREE_PERIOD' | 'TIME_INTERVAL';
};

export type UpdateSettlementStaysDTO = SettlementStaysDTO;
